// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/companies/$companyKey/fulfillment')(
  {
    component: CompanyFulfillmentRoute,
  }
);

function CompanyFulfillmentRoute() {
  const { companyKey } = Route.useParams();
  return <Navigate to="/companies/$companyKey" params={{ companyKey }} />;
}
